class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification-wrapper');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button.modal__close-button').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      {once: true}
    );

    document.body.addEventListener('click', this.onBodyClick);
    document.body.classList.add('no-scroll');
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('no-scroll');

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, payload) {
    let productData = payload;
    // Multiple add to cart response
    if (parsedState.items) {
      const primaryProduct = parsedState.items.filter((item) => !item.properties._addonType);
      if (!primaryProduct.length) return;
      this.cartItemKey = primaryProduct[0].id;
      parsedState.sections &&
        this.getSectionsToRender().forEach((section) => {
          if (section.id !== 'cart-notification-product') {
            document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.id],
              section.selector
            );
          }
        });
      if (!productData) return;
      productData = JSON.parse(productData);
      if (!productData.items || !productData.items.length) return;
      const mainProduct = productData.items[0];
      const soupItems = productData.items.filter(
        (item) =>
          item.properties && item.properties._addonType && item.properties._addonType === 'Soup'
      );
      const cookieItems = productData.items.filter(
        (item) =>
          item.properties && item.properties._addonType && item.properties._addonType === 'Cookies'
      );
      const addonItems = productData.items.filter(
        (item) =>
          item.properties &&
          item.properties._addonType &&
          item.properties._addonType === 'Care Package'
      );

      const packagingItems = productData.items.filter(
        (item) =>
          item.properties &&
          item.properties._addonType &&
          item.properties._addonType === 'Packaging'
      );

      const container = document.getElementById('cart-notification-product');
      if (!container) return;
      container.innerHTML = '';

      const imageWrapper = document.createElement('div');
      imageWrapper.classList.add('cart-notification-product__image');
      imageWrapper.classList.add('global-media-settings');
      const image = document.createElement('img');
      image.height = '145';
      image.width = '145';
      image.src = mainProduct.imageUrl;
      imageWrapper.appendChild(image);

      container.appendChild(imageWrapper);

      const contentWrapper = document.createElement('div');
      const productTitle = document.createElement('h3');
      productTitle.classList.add('cart-notification-product__name');
      productTitle.classList.add('h4');
      productTitle.textContent = mainProduct.title;
      contentWrapper.appendChild(productTitle);

      const addonsWrapper = document.createElement('dl');

      if (soupItems.length) {
        const soupWrapper = document.createElement('div');
        soupWrapper.classList.add('product-option');
        // const soupTitle = document.createElement('dt');
        // soupTitle.textContent = soupItems.length > 1 ? 'Soups: ' : 'Soup: ';
        const soupTitles = document.createElement('dd');
        for (var x = 0; x < soupItems.length; x++) {
          if (x == soupItems.length - 1) {
            soupTitles.textContent += soupItems[x].properties._addonName;
          } else {
            soupTitles.textContent += soupItems[x].properties._addonName + ', ';
          }
        }
        // soupWrapper.appendChild(soupTitle);
        soupWrapper.appendChild(soupTitles);
        addonsWrapper.appendChild(soupWrapper);
      }

      if (cookieItems.length) {
        const cookieWrapper = document.createElement('div');
        cookieWrapper.classList.add('product-option');
        // const cookieTitle = document.createElement('dt');
        // cookieTitle.textContent = cookieItems.length > 1 ? 'Cookies: ' : 'Cookie: ';
        const cookieTitles = document.createElement('dd');
        for (var x = 0; x < cookieItems.length; x++) {
          if (x == cookieItems.length - 1) {
            cookieTitles.textContent += cookieItems[x].properties._addonName;
          } else {
            cookieTitles.textContent += cookieItems[x].properties._addonName + ', ';
          }
        }
        // cookieWrapper.appendChild(cookieTitle);
        cookieWrapper.appendChild(cookieTitles);
        addonsWrapper.appendChild(cookieWrapper);
      }

      if (addonItems.length) {
        const addonWrapper = document.createElement('div');
        addonWrapper.classList.add('product-option');
        // const addonTitle = document.createElement('dt');
        // addonTitle.textContent = addonItems.length > 1 ? 'Care Packages: ' : 'Care Package: ';
        const addonTitles = document.createElement('dd');
        for (var x = 0; x < addonItems.length; x++) {
          if (x == addonItems.length - 1) {
            addonTitles.textContent += addonItems[x].properties._addonName;
          } else {
            addonTitles.textContent += addonItems[x].properties._addonName + ', ';
          }
        }
        // addonWrapper.appendChild(addonTitle);
        addonWrapper.appendChild(addonTitles);
        addonsWrapper.appendChild(addonWrapper);
      }

      if (packagingItems.length) {
        const packagingWrapper = document.createElement('div');
        packagingWrapper.classList.add('product-option');
        // const packagingTitle = document.createElement('dt');
        // packagingTitle.textContent = 'Packaging: ';
        const packagingTitles = document.createElement('dd');
        for (var x = 0; x < packagingItems.length; x++) {
          packagingTitles.textContent += packagingItems[x].properties._addonName;
        }
        // packagingWrapper.appendChild(packagingTitle);
        packagingWrapper.appendChild(packagingTitles);
        addonsWrapper.appendChild(packagingWrapper);
      }

      contentWrapper.appendChild(addonsWrapper);

      const priceWrapper = document.createElement('div');
      priceWrapper.classList.add('cart-notification-product__price');
      priceWrapper.textContent = mainProduct.price;
      contentWrapper.appendChild(priceWrapper);
      container.appendChild(contentWrapper);
    }
    // Regular add to cart response
    else {
      this.cartItemKey = parsedState.id;
      this.cartItemProperties = parsedState.properties;
      this.getSectionsToRender().forEach((section) => {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      });
    }
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    const selector =
      this.cartItemProperties && this.cartItemProperties._timeStamp
        ? `${this.cartItemKey}-${this.cartItemProperties._timeStamp}`
        : `${this.cartItemKey}-`;
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${selector}"]`
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
